import React, { useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Autocomplete, Box, Button, Card, Chip, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack, Edit } from '@mui/icons-material';
import { useForm ,Controller, FormProvider} from 'react-hook-form';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Helpers } from '../../../services/Helpers';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { BannerServices } from './BannerServices';
import Swal from 'sweetalert2';
import Loading from '../../../components/Loader/Loading';
import calculateAspectRatio from '../../../utils/calculateRatio';

const ViewBannerDetails = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const initialState = {
        title: '',
        imageUrl:'',
        platforms:[],
        bannerType:'',
        bannerPosition:'',
        bannerCategory:'',
        linkUrl:'',
        position:'',
        startDate:'',
        expireDate:'',
        startTime:'',
        endTime:'',
        latitude:'',
        longitude:'',
        coverageArea:'',
        status:false,

    }
    const [bannerData,setBannerData] = useState(initialState);
    const [isLoading,setIsLoading] = useState(false);
    const fetchBannerData = async()=>{
        setIsLoading(true);
        try {
            const response = await BannerServices.getBannerById(id);
        console.log("fetching Banner Details response",response);
        if(response.success == '1'){
            const data = response.data;
            const requiredData = {
                title: data.title,
                imageUrl: data.imageUrl,
                width: data.dimension?.split('x')[0],
                height: data.dimension?.split('x')[1],
                aspectRatio: data.dimension? calculateAspectRatio(data.dimension?.split('x')[0], data.dimension?.split('x')[1]) : '',
                platformName: data.platformName,
                bannerType: data.bannerType,
                bannerPosition: data.bannerPosition,
                bannerCategory: data.bannerCategory,
                linkUrl: data.linkUrl,
                appUrl: data.appUrl,
                position: data.position,
                startDate: data.startDate ? dayjs(data.startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                startTime: data.startDate ? dayjs(data.startDate).format('HH:mm') : null,
                expireDate: data.expireDate ? dayjs(data.expireDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                endTime: data.expireDate ? dayjs(data.expireDate).format('HH:mm') : null,
                latitude: data.latitude,
                longitude: data.longitude,
                coverageArea: data.areaInKm,
                status: data.status
            }
            setBannerData(requiredData);
        }
        } catch (error) {
            console.log("fetching Banner Details error",error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.message,
                timer: 2000
            });
        }finally{
            setIsLoading(false);
        }
    }
    
    useEffect(()=>{
        if(id>0){
            // fetch banner data by id
            fetchBannerData();
            // const data ={
            //     "title": "banner title",
            //     "imageUrl": "staging/banner/home/slider/screenshot-2025-01-16-153306-1739102951363.png",
            //     "platforms": [
            //         "Customer-App",
            //         "SE-App"
            //     ],
            //     "bannerType": "Homescreen_Caraousel",
            //     "bannerPosition": "Middle",
            //     "bannerCategory": "interactive",
            //     "linkUrl": "gfdghghvhjvjhvjvjvjhvjvjngvghvhj",
            //     "position": "134",
            //     "startDate": "2025-02-13T14:10:00.000Z",                
            //     "expireDate": "2025-02-14T14:10:00.000Z",
            //     "latitude": "11",
            //     "longitude": "12",
            //     "coverageArea": "13",
            //     "status": false
            // }
            // setBannerData(data);
        }
    },[])
  return (
    <>
        {isLoading && <Loading/> }
        <PageHeaderLayout headerTitle={`Banner Detail's`}>
          <Button variant='contained'  onClick={()=>navigate('/marketing/banners')} sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}>
            Show Banner List
          </Button>
        </PageHeaderLayout>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
            <Card sx={{p:2}}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Title</Typography>
                        <TextField 
                          disabled
                          value={bannerData.title}
                          fullWidth 
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Platform</Typography>
                        <TextField
                          disabled
                          value={bannerData?.platformName}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                        
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Position</Typography>
                        <TextField
                          disabled
                          value={bannerData.bannerPosition}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Category</Typography>
                        <TextField
                          disabled
                          value={bannerData.bannerCategory}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                            Aspect Ratio <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box>
                        </Typography>
                        <TextField
                            size='small'
                            disabled
                            value={bannerData.aspectRatio}
                            fullWidth
                            InputProps={{ style: { fontSize: '0.75rem' } }}
                        />
                    </Grid>
                    
                    {/* <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                            Image Height (px) <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box>
                        </Typography>
                        
                    </Grid> */}
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                            Banner Dimension (px)
                        </Typography>
                        <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                            <TextField
                                size='small'
                                disabled
                                value={bannerData.width}
                                fullWidth
                                inputProps={{ style: { fontSize: '0.75rem' } }}
                            />
                            <Typography sx={{fontSize:'0.75rem'}}>X</Typography>
                            <TextField
                                size='small'
                                disabled
                                value={bannerData.height}
                                fullWidth
                                inputProps={{ style: { fontSize: '0.75rem' } }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={5.5} >
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Banner Type</Typography>
                        <TextField 
                          disabled
                          value={bannerData.bannerType}
                          fullWidth
                          size='small'
                          InputProps={{

                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Attached Link</Typography>
                        <TextField
                          disabled
                          value={bannerData.linkUrl || bannerData.appUrl}
                          fullWidth
                          size='small'
                          
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Start Date</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                              disabled
                              sx={{
                                  width: '100%',
                                  '& .MuiInputBase-root': {
                                      fontSize: '0.75rem'
                                  }
                              }}
                              value={bannerData.startDate ? dayjs(bannerData.startDate) : null}
                              format="DD-MM-YYYY"
                              slotProps={{
                                  textField: {
                                      fullWidth: true,
                                      size: 'small',
                                      inputProps: {
                                          style: { fontSize: '.75rem' }
                                      }
                                  }
                              }}
                          />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Start Time</Typography>
                        <TextField
                          disabled
                          value={dayjs(bannerData.startDate).format('HH:mm')}
                          fullWidth
                          size='small'
                          type='time'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>End Date</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                              disabled
                              sx={{
                                  width: '100%',
                                  '& .MuiInputBase-root': {
                                      fontSize: '0.75rem'
                                  }
                              }}
                              value={bannerData.expireDate ? dayjs(bannerData.expireDate) : null}
                              format="DD-MM-YYYY"
                              slotProps={{
                                  textField: {
                                      fullWidth: true,
                                      size: 'small',
                                      inputProps: {
                                          style: { fontSize: '.75rem' }
                                      }
                                  }
                              }}
                          />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>End Time</Typography>
                        <TextField
                          disabled
                          value={dayjs(bannerData.expireDate).format('HH:mm')}
                          fullWidth
                          size='small'
                          type='time'
                          InputProps={{ 
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Latitude</Typography>
                        <TextField
                          disabled
                          value={bannerData.latitude}
                          fullWidth
                          size='small'
                          InputProps={{

                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Longitude</Typography>
                        <TextField
                          disabled
                          value={bannerData.longitude}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Coverage Area( in km)</Typography>
                        <TextField
                          disabled
                          value={bannerData.coverageArea}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={12} sm={5.5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Slider Position</Typography>
                        <TextField
                          disabled
                          value={bannerData.position == 0 && ''}
                          fullWidth
                          size='small'
                          InputProps={{
                              style: {fontSize:'0.75rem'}
                          }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </Grid>
        {/* ==========  Image Section  ========= */}
        <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ p: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                    Banner Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                </Typography>
                
                <Box sx={{ mb: 2, textAlign: 'center' }}>                        
                  <Box sx={{ mb: 2, justifyContent: 'center',boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                      <img
                          src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${bannerData.imageUrl}`}
                          alt="Service"
                          style={{ maxWidth: '100%', height: 'auto' }}
                      />
                  </Box>
                </Box>

                <Box sx={{ mt: 3, textAlign: 'center' }}>
                    <PermissionGuard feature={'banner'} permission='canEdit' >
                      <Button 
                          onClick={()=>navigate(`/marketing/banner/${id}`)}
                          variant="contained"
                          color="warning"
                          size='small'
                          fullWidth
                          startIcon={<Edit />}
                      >
                          {'Edit'}
                      </Button>
                    </PermissionGuard>
                </Box>
            </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default ViewBannerDetails;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? '0' : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};